import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-content unselectable" }
const _hoisted_3 = { class: "footer-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.STRINGS.COPYRIGHT + " " + _ctx.STRINGS.CLINIC_NAME), 1),
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ROUTES_ARRAY, (route) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: route.path,
            to: route.path
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(route.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ])
    ])
  ]))
}